import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    documento: null,
    saved: false,
    refresh: false,
    refreshTestata: false,
    refreshDettaglio: false,
    refreshDettaglioScontrini: false,
    refreshMultiple: false,
    refreshMultipleScontrini: false,
    refreshProforma: false,
    refreshDefinitive: false,
    page: 'testate',
    gotoBase: false,
    chiave: null,
    creaArticolo: false,
    articoloCreato: null,
    creaClifor: false,
    cliforCreato: null
  },
  getters: {
    documento: state => state.documento,
    saved: state => state.saved,
    refresh: state => state.refresh,
    refreshTestata: state => state.refreshTestata,
    refreshDettaglio: state => state.refreshDettaglio,
    refreshDettaglioScontrini: state => state.refreshDettaglioScontrini,
    refreshMultiple: state => state.refreshMultiple,
    refreshMultipleScontrini: state => state.refreshMultipleScontrini,
    refreshProforma: state => state.refreshProforma,
    refreshDefinitive: state => state.refreshDefinitive, 
    page: state => state.page,
    gotoBase: state => state.gotoBase,
    chiave: state => state.chiave,
    creaArticolo: state => state.creaArticolo,
    articoloCreato: state => state.articoloCreato,
    creaClifor: state => state.creaClifor,
    cliforCreato: state => state.cliforCreato
  },
  mutations: {
    SET_DOCUMENTO (state, payload) {
      state.documento = payload
    },
    CLEAR_DOCUMENTO (state) {
      state.documento = null
    },
    SET_DOCUMENTO_SAVED (state) {
      state.saved = true
    },
    CLEAR_DOCUMENTO_SAVED (state) {
      state.saved = false
    },
    SET_REFRESH (state, value) {
      if (value === 'testata') state.refreshTestata = true
      if (value === 'dettaglio') state.refreshDettaglio = true
      if (value === 'dettaglioScontrini') state.refreshDettaglioScontrini = true
      if (value === 'multiple') state.refreshMultiple = true
      if (value === 'multipleScontrini') state.refreshMultipleScontrini = true
      if (value === 'proforma') state.refreshProforma = true
      if (value === 'definitive') state.refreshDefinitive = true
      if (!value && state.page) {
        if (state.page === 'testata') state.refreshTestata = true
        if (state.page === 'dettaglio') state.refreshDettaglio = true
        if (value.page === 'multiple') state.refreshMultiple = true
      }
    },
    CLEAR_REFRESH (state, value) {
      if (value === 'testata') state.refreshTestata = false
      if (value === 'dettaglio') state.refreshDettaglio = false
      if (value === 'dettaglioScontrini') state.refreshDettaglioScontrini = false
      if (value === 'multiple') state.refreshMultiple = false
      if (value === 'multipleScontrini') state.refreshMultipleScontrini = false
      if (value === 'proforma') state.refreshProforma = false
      if (value === 'definitive') state.refreshDefinitive = false
      if (!value && state.page) {
        if (state.page === 'testata') state.refreshTestata = false
        if (state.page === 'dettaglio') state.refreshDettaglio = false
        if (value.page === 'multiple') state.refreshMultiple = false
      }
    },
    SET_PAGE (state, value) {
      state.page = value
    },
    SET_GOTO_BASE (state) {
      state.gotoBase = true
    },
    CLEAR_GOTO_BASE (state) {
      state.gotoBase = false
    },
    SET_CHIAVE(state, payload) {
      state.chiave = payload
    },
    SET_CREA_ARTICOLO(state) {
      state.creaArticolo = true
    },
    CLEAR_CREA_ARTICOLO(state) {
      state.creaArticolo = false
    },
    SET_ARTICOLO_CREATO(state, payload) {
      state.articoloCreato = payload
    },
    SET_CREA_CLIFOR(state) {
      state.creaClifor = true
    },
    CLEAR_CREA_CLIFOR(state) {
      state.creaClifor = false
    },
    SET_CLIFOR_CREATO(state, payload) {
      state.cliforCreato = payload
    }
  },
  actions: {
  }
}
